export const GLOBAL_NOTE_TYPE = 'GlobalNote';
const FORM_KEY_VERSION_1 = 'data';
const FORM_KEY_VERSION_2 = '_note_';

export const fixTypeNoteConfigurationVersion2AsVersion1 = (typeNote: any, data: any) => {
    const newData = { ...data };
    if (typeNote && newData && typeNote.name.toLowerCase() === GLOBAL_NOTE_TYPE.toLowerCase()) {
        if (
            FORM_KEY_VERSION_1 in typeNote.configuration.customFields.componentForms[0] &&
            FORM_KEY_VERSION_2 in newData
        ) {
            newData[FORM_KEY_VERSION_1] = newData[FORM_KEY_VERSION_2];
            return newData;
        }
    }
    return newData;
};

export const findForwarderNodeConfigurationForm: any = (customFields: any) => {
    if (customFields && 'forwarderNodeConfiguration' in customFields) {
        return findForwarderNodeConfigurationForm(customFields?.forwarderNodeConfiguration?.customFields);
    }
    return customFields?.componentForms;
};
